import {useEffect, useState} from "react";
import {getLastClosedGroups, getLastInsertedGroups} from "../utils/GroupUtils";
import useQueryCaller from "./useQueryCaller";

export default function useDashboardQueryParams(filterValue) {
    const [params, setParams] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const queryCaller = useQueryCaller();

    useEffect(() => {
        setParams(undefined);
        if (
            filterValue?.unit === "lastInsertedGroups" ||
            filterValue?.unit === "lastClosedGroups"
        ) {
            async function fetchData() {
                try {
                    setLoading(true);
                    const result =
                        filterValue?.unit === "lastInsertedGroups"
                            ? await getLastInsertedGroups(
                                  queryCaller,
                                  filterValue?.limit
                              )
                            : await getLastClosedGroups(
                                  queryCaller,
                                  filterValue?.limit
                              );
                    setParams([result.map((item) => item.group_nr)]);
                } catch (e) {
                    console.error(e);
                } finally {
                    setLoading(false);
                }
            }

            fetchData();
            return;
        }
    }, [filterValue]); // eslint-disable-line react-hooks/exhaustive-deps

    return [params, loading];
}
